@if(type() === 'richtext') {
  <div #textContainer [innerHTML]="innerHTML()" [class]="richtextClassName()" [attr.data-richtext]="'true'" appTranslate></div>
  @if(showReadMore() && !isExpanded()) {
    <span class="cursor-pointer text-decoration-none fs-default fw-bold {{ fontColor() ?? 'text-muted' }}" (click)="expand()">{{'SEEMORETEXT' | translate}}</span>
  }
  @if(collapsible() && isExpanded()) {
    <span
      class="cursor-pointer text-decoration-none fs-default fw-bold {{ fontColor() ?? 'text-muted' }}"
      (click)="collapse()">
      {{ 'SHOWLESSTEXT' | translate }}
    </span>
  }
} @else {
  <span [class]="defaultClassName()" appTranslate><ng-content></ng-content></span>
}
